import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ProductSlider from '../product/ProductSlider';
import ProductCard from '../product/ProductCard';

export default function ProductTabs({ section }) {
  const d = section.data || {};
  const tabs = section.tabs || [];
  const [active, setActive] = useState(0);
  if (!tabs.length) return null;
  const tab = tabs[active] || tabs[0];
  const cols = Number(d.columns) || 6;

  return (
    <section className="sf__product-tab tab__header-horizontal" style={{ backgroundColor: d.background || 'rgba(0,0,0,0)', '--column-gap': '30px', '--column-gap-mobile': '10px', '--row-gap': '40px' }}>
      <div className="container-fluid section-my">
        {d.heading && (
          <div className="section__header text-center">
            {d.subheading && <p className="section__subheading">{d.subheading}</p>}
            <h2 className="section__heading">{d.heading}</h2>
          </div>
        )}
        <div className="sf-tabs-container product-tabs__wrapper">
          {tabs.length > 0 && (
            <div className="product-tabs__header product-tabs__header--horizontal flex justify-center flex-wrap text-[1.125rem] mb-8">
              {tabs.map((t, i) => (
                <button type="button" key={i} className={`sf-tab-header mx-6 ${i === active ? 'active' : ''}`} onClick={() => setActive(i)}>{t.title}</button>
              ))}
            </div>
          )}
          <div className="product-tabs__content">
            <div className="sf-tab-content active">
              {d.slider === false ? (
                <div className="sf__ms">
                  <div className={`sf-grid grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-${Math.min(cols, 6)}`} style={{ gap: 'var(--row-gap) var(--column-gap)' }}>
                    {tab.products.map((p) => (
                      <div className="sf-column" key={p._id}><ProductCard product={p} /></div>
                    ))}
                  </div>
                </div>
              ) : (
                <ProductSlider products={tab.products} columns={cols} id={`tabs-${section.id}-${active}`} />
              )}
            </div>
          </div>
          {(tab.url || d.buttonText) && (
            <div className="text-center mt-10">
              <Link to={tab.url || '/collections/all'} className="sf__btn sf__btn-secondary">{d.buttonText || 'View all'}</Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
